"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
/**
 *
 * @param firestore
 * @param uid uid del paciente
 */
async function getRequestsDelivery(firestore, uid) {
    const path = "events/requests/delivery";
    const deliveryRef = (0, firestore_1.collection)(firestore, path);
    const validStatus = ["PREASSIGN", "PREASSIGN:PENDING", "PREASSIGN:NOTFOUND", "ABSENT", "ASSIGN:DELIVERY", "ASSIGN:ARRIVED", "DONE", "DONE:LAB", "DONE:RESULT", "DONE:REJECTED"];
    const deliveryQuery = (0, firestore_1.query)(deliveryRef, (0, firestore_1.where)("status", "in", validStatus), (0, firestore_1.where)("patient.uid", "==", uid));
    let delivery;
    const deliveryArray = [];
    try {
        delivery = await (0, firestore_1.getDocs)(deliveryQuery);
    }
    catch (err) {
        throw new Error(`${err}`);
    }
    delivery.forEach(object => deliveryArray.push({ ...object.data(), docId: object.id }));
    return deliveryArray;
}
exports.default = getRequestsDelivery;
